const convertColorToRgba = require('../convertColorToRgba');

/**
 * Color comparison
 * @param {String} color color
 * @param {String} otherColor other color
 * @param {Boolean} ignoreAlpha ignore alpha channel
 * @return {Boolean}
 */
const isEqualColor = (color, otherColor, ignoreAlpha = false) => {
    const colorRgba = convertColorToRgba(color);
    const otherColorRgba = convertColorToRgba(otherColor);

    const equalR = colorRgba.r === otherColorRgba.r;
    const equalG = colorRgba.g === otherColorRgba.g;
    const equalB = colorRgba.b === otherColorRgba.b;
    const equalColor = equalR && equalG && equalB;

    if (ignoreAlpha) {
        return equalColor;
    }

    const equalA = colorRgba.a === otherColorRgba.a;
    return equalA && equalColor;
};

module.exports = isEqualColor;
